<template>
  <div class="app-body">
    <el-form :model="dataForm" ref="dataForm" label-width="120px">
      <el-card>
        <div slot="header" class="card-header">
          <div>发货计划</div>
          <div>
            <el-date-picker
              v-model="planDate"
              type="date"
              value-format="yyyy-MM-dd"
              style="margin-right: 20px"
              placeholder="选择发货日期"
            >
            </el-date-picker>
            <el-button
              size="mini"
              icon="el-icon-plus"
              @click="addRow()"
              type="primary"
              >添加计划</el-button
            >
          </div>
        </div>
        <el-table
          :data="dataForm.detailList"
          :height="tblHeight"
          border
          style="width: 100%"
          ref="table"
        >
          <el-table-column
            type="index"
            width="50"
            label="行号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column label="品番号" width="230" prop="code" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="SKU" width="220" prop="skuCode" header-align="center" align="center">
          </el-table-column>
          <el-table-column label="品名" width="230" align="center" prop="name">
          </el-table-column>
          <el-table-column
              label="颜色"
              prop="color"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="规格"
              prop="size"
              header-align="center"
              align="center"
              width="100"
          >
          </el-table-column>
          <el-table-column
            label="合同数量"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              {{ scope.row.count }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(column, index) in planList"
            :key="index"
            :label="column"
            header-align="center"
            align="center"
            width="160"
          >
            <template slot="header" slot-scope="scope">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div style="height: 18px; vertical-align: bottom">
                  {{ scope.column.label }}
                </div>
                <i
                  class="el-icon-error"
                  style="
                    font-size: 18px;
                    font-weight: bold;
                    cursor: pointer;
                    margin-left: 10px;
                  "
                  @click="removePlan(scope.column)"
                ></i>
              </div>
            </template>
            <template slot-scope="scope">
              <el-form-item
                :prop="'detailList.' + scope.$index + '.' + scope.column.label"
                :rules="detailRule.count"
                label-width="0"
                style="margin-top: 20px"
              >
                <el-input
                  v-model="scope.row[column]"
                  @change="reComputedLimitCount"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column
            label="剩余数量"
            header-align="center"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-tag :type="scope.row.limitCount > 0 ? 'danger' : 'success'">{{
                scope.row.limitCount
              }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-form>
    <div class="footer">
      <el-button v-if="!step" @click="cancel()">取消</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        step ? "完成" : "保存计划"
      }}</el-button>
    </div>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import BigNumber from "bignumber.js";
import mixinViewModule from "@/mixins/view-module";
import SaveRule from "./save-rule";

export default {
  mixins: [mixinViewModule, SaveRule],
  components: {},
  data() {
    return {
      planDate: "",
      agreementId: "",
      dataForm: { agreementId: "", detailList: [] },
      currentDetailIndex: {},
      mixinViewModuleOptions: {
        getDataListURL: "/trade/agreement/detail/list",
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      tblHeight: 300,
      planList: [],
      step: 0,
    };
  },
  mounted() {
    setTimeout(() => {
      this.tblHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - 190;
    }, 100);
  },
  activated() {
    this.reset();
    this.step = this.$route.query.step;
    this.agreementId = this.$route.query.agreementId;
    this.dataForm.agreementId = this.agreementId;
    if (this.agreementId) {
      this.getDataList();
    } else {
      this.dataList = [];
      this.planList = [];
    }
  },
  methods: {
    getPlanList() {
      if (!this.agreementId) {
        return;
      }
      this.$http
        .get(`/trade/plan/list`, { params: { agreementId: this.agreementId } })
        .then(({ data: res }) => {
          if (res.data) {
            let tmpPlan = [];
            res.data.forEach((plan) => {
              if (tmpPlan.find((m) => m == plan.sendDate)) {
                return;
              }
              tmpPlan.push(plan.sendDate);
            });
            this.planList = tmpPlan;
            this.planList.forEach((plan) => {
              this.dataForm.detailList.forEach((item) => {
                const planInfo = res.data.find(
                  (m) => m.sendDate === plan && m.agreementDetailId === item.id
                );
                this.$set(item, plan, planInfo ? planInfo.count : 0);
              });
            });
            this.reComputedLimitCount();
          }
        });
    },
    removePlan(column) {
      console.log("removePlan", column);
      for (let i = this.planList.length - 1; i >= 0; i--) {
        let item = this.planList[i];
        if (item === column.label) {
          this.planList.splice(i, 1);
        }
      }
      this.dataForm.detailList.forEach((row) => {
        this.$delete(row, column.label);
      });
      this.reComputedLimitCount();
    },
    reComputedLimitCount() {
      this.dataForm.detailList.forEach((row) => {
        let sendCount = new BigNumber(0);
        this.planList.forEach((plan) => {
          if (!row[plan]) {
            return;
          }
          let tc = new BigNumber(row[plan]);
          if (!tc.isInteger) {
            return;
          }
          sendCount = sendCount.plus(tc);
        });
        row.limitCount = row.count - sendCount.toNumber();
      });
    },
    beforeTableBinding(dataList) {
      dataList.forEach((item) => {
        item.limitCount = item.count;
      });
    },
    afterTableBinding(dataList) {
      this.dataForm.detailList = dataList;
      this.getPlanList();
    },

    addRow() {
      if (!this.planDate) {
        return this.$message.error("请先选择发货日期");
      }
      if (this.planList.find((item) => item === this.planDate)) {
        return this.$message.error("计划日期重复");
      }
      this.planList.push(this.planDate);
      this.dataForm.detailList.forEach((item) => {
        this.$set(item, this.planDate, 0);
      });
      console.log("this.dataForm.detailList", this.dataForm.detailList);
    },
    reset() {
      this.dataForm.planDate = "";
      this.dataForm.agreementId = "";
      this.dataForm.detailList = [];
      this.$nextTick(() => {
        if (this.$refs["dataForm"]) {
          this.$refs["dataForm"].resetFields();
        }
        this.agreementId = this.$route.query.agreementId;
      });
    },
    cancel() {
      if (this.step) {
        this.$router.replace(`/trade-agreement-index`);
      } else {
        this.$router.back();
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function() {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.reComputedLimitCount();
          //判断是否有剩余未发货
          for (let i = 0; i < this.dataForm.detailList.length; i++) {
            const item = this.dataForm.detailList[i];
            if (item.limitCount > 0) {
              return this.$message.error("有货物未设置发货计划");
            }
          }
          let postForm = [];
          this.planList.forEach((plan) => {
            this.dataForm.detailList.forEach((item) => {
              postForm.push({
                agreementDetailId: item.id,
                sendDate: plan,
                count: item[plan],
              });
            });
          });
          const loading = this.$loading();
          this.$http
            .post("/trade/plan/save", postForm)
            .then(({ data: res }) => {
              loading.close();
              if (res.code !== 0) {
                return this.$message.error(res.msg);
              }
              this.$message({
                message: "保存成功",
                type: "success",
                duration: 500,
                onClose: () => {
                  this.$router.push(`/trade-agreement-index`);
                },
              });
            })
            .catch((e) => {
              console.log(e);
              loading.close();
            });
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
  },
};
</script>
